import { render, staticRenderFns } from "./LinkVariantPlusIcon.vue?vue&type=template&id=2f728328"
import script from "./LinkVariantPlusIcon.vue?vue&type=script&lang=js"
export * from "./LinkVariantPlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports